import { TicketSelectionApplicationData } from "@/domain/ticket-selection";
import { ObjectUtils } from "webshop-modules";

/**
 * InGroupsOfRequirementsProvider
 */
export class InGroupsOfRequirementsProvider {

    /**
     * whatItDoes
     * decorates priceList ticketTypes with inGroupsOf priceLevel setting
     */
    public static decorateTicketTypesWithPriceLevelInGroupsOfSetting(
        data: TicketSelectionApplicationData
    ): TicketSelectionApplicationData {
        if (!data.priceList) {
            return data;
        }

        if (!data.priceList.priceLevels || !data.priceList.priceLevels.length) {
            return data;
        }

        const src: TicketSelectionApplicationData = ObjectUtils.clone(data);
        src.priceList!.priceLevels = src.priceList!.priceLevels!
            .map(level => {
                if (!level.inGroupsOf || !level.promotionHolds) { return level; }

                level.promotionHolds = level.promotionHolds.map(promotionHolds => {
                    if (!promotionHolds.holds) { return promotionHolds; }

                    promotionHolds.holds = promotionHolds.holds.map(hold => {
                        if (!hold.ticketTypes) { return hold; }

                        hold.ticketTypes = hold.ticketTypes.map(tt => {
                            tt.onlyInGroupsOfPerOrder = tt.onlyInGroupsOfPerOrder || level.inGroupsOf;
                            return tt;
                        });
                        return hold;
                    });
                    return promotionHolds;
                });
                return level;
            });

        return src;
    }

}
